import { render } from "./DetailField.vue?vue&type=template&id=faedd42a"
import script from "./DetailField.vue?vue&type=script&lang=js"
export * from "./DetailField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__